module.exports = __webpack_public_path__ + "img/icon-input-clear.21e67564.svg";